module.exports = __webpack_public_path__ + "static/apple-icon-120x120-65038012566217c42d138247d162774f.png";